module.exports = __webpack_public_path__ + "img/gdzbzz_bd.6464b2f.png";